import { cellRenderButtonModalSK } from '../ModalSK/functionModalSK';
import {
  cellRenderParseData,
  cellRenderStatus,
  cellRenderStatusAct,
  cellRenderStorageTimeCount
} from '../../utils/functions';
import { cellRenderPopupActM3 } from '../PopupActMVP/functionPopupAct';

const columnDataM4 = [
  {
    dataField: 'pieceNumId',
    caption: 'Ключ УЕ',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'qcShopCode',
    caption: 'Код цеха отгрузки',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'qcId',
    caption: '№ СК',
    dataType: 'string',
    cellRender: cellRenderButtonModalSK,
    cssClass: 'td-button-cell-render'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'psStatusNumId',
    caption: 'ID статуса',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    cellRender: cellRenderStatus,
    dataType: 'string'
  },
  {
    dataField: 'soDescrId',
    caption: '№ Заказа',
    dataType: 'string'
  },
  {
    dataField: 'l4SoId',
    caption: '№ СЗ сист.',
    dataType: 'string'
  },
  {
    dataField: 'soLineDescrId',
    caption: 'Позиция заказа',
    dataType: 'number'
  },
  {
    dataField: 'zzordOtsortConf',
    caption: 'Признак ОХ из заказа',
    dataType: 'string'
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: '№ партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: '№ УЕ',
    dataType: 'string'
  },
  {
    dataField: 'heatId',
    caption: '№ плавки',
    dataType: 'string'
  },
  {
    dataField: 'thick',
    caption: 'Толщина, мм',
    dataType: 'number'
  },
  {
    dataField: 'width',
    caption: 'Ширина, мм',
    dataType: 'number'
  },
  {
    dataField: 'length',
    caption: 'Длина, мм',
    dataType: 'number'
  },
  {
    dataField: 'weightNetto',
    caption: 'Вес нетто, т',
    dataType: 'number'
  },
  {
    dataField: 'weightBrutto',
    caption: 'Вес брутто, т',
    dataType: 'number'
  },
  {
    dataField: 'vehicleIdIn',
    caption: '№ ТС первого плеча',
    dataType: 'string'
  },
  {
    dataField: 'customerName',
    caption: 'Грузополучатель рус.',
    dataType: 'string'
  },
  {
    dataField: 'customerNameEng',
    caption: 'Грузополучатель анг.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoAddressSo',
    caption: 'Адрес получателя рус.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoAddressEnSo',
    caption: 'Адрес получателя англ.',
    dataType: 'string'
  },
  {
    dataField: 'shiptoStationNameSo',
    caption: 'Ст.назначения',
    dataType: 'string'
  },
  {
    dataField: 'shiptoStationCodeSo',
    caption: 'Код станции назначения',
    dataType: 'string'
  },
  {
    dataField: 'shiptoRailwayNameSo',
    caption: 'ЖД назначения',
    dataType: 'string'
  },
  {
    dataField: 'knotPurposeSo',
    caption: 'Целевой узел',
    dataType: 'string'
  },
  {
    dataField: 'shippingPoint',
    caption: 'Пункт отправки',
    dataType: 'string'
  },
  {
    dataField: 'sapId',
    caption: '№ УЭ SAP',
    dataType: 'string'
  },
  {
    dataField: 'shipmentModeRequirement',
    caption: 'Способ отгрузки',
    dataType: 'string'
  },
  {
    dataField: 'planDatePps',
    caption: 'Плановая дата отгрузки с комбината',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'serialId',
    caption: 'Данные штрих-кода для УЭ',
    dataType: 'number'
  },
  {
    dataField: 'container',
    caption: '№ контейнера',
    dataType: 'string'
  },
  {
    dataField: 'dateLoadInContainer',
    caption: 'Дата загрузки контейнера',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'plomba',
    caption: '№ пломбы',
    dataType: 'string'
  },
  {
    dataField: 'ttn',
    caption: '№ ЖД накладной',
    dataType: 'string'
  },
  {
    dataField: 'ttnDate',
    caption: 'Дата накладной',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'vehicleIdOut',
    caption: '№ ТС отгруженного с УС',
    dataType: 'string'
  },
  {
    dataField: 'incomingDate',
    caption: 'Дата приёмки на склад',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'incomingTime',
    caption: 'Время приёмки на склад',
    dataType: 'string'
  },
  {
    dataField: 'shippingDate',
    caption: 'Дата отгрузки с УС',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'shippingTime',
    caption: 'Время отгрузки с УС',
    dataType: 'string'
  },
  {
    dataField: 'incomingUser',
    caption: 'ФИО принявшего',
    dataType: 'string'
  },
  {
    dataField: 'stockDescr',
    caption: 'Склад',
    dataType: 'string'
  },
  {
    dataField: 'areaDescr',
    caption: 'Зона',
    dataType: 'string'
  },
  {
    dataField: 'boxDescr',
    caption: 'Бокс',
    dataType: 'string'
  },
  {
    dataField: 'qcShopDescr',
    caption: 'Цех-отправитель',
    dataType: 'string'
  },
  {
    dataField: 'storageTimeCount',
    caption: 'Срок хранения',
    dataType: 'number'
  },
  {
    dataField: 'remainingTimeCount',
    caption: 'Осталось времени',
    cellRender: cellRenderStorageTimeCount,
    cssClass: 'td-button-cell-render',
    dataType: 'number'
  },
  {
    dataField: 'mh3',
    caption: 'МХ-3',
    cellRender: cellRenderPopupActM3,
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'mh3NumId',
    caption: 'id МХ-3',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh3DocStatus',
    caption: 'id МХ-3 Doc Status',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh3Date',
    caption: 'Дата МХ-3',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'mh3Status',
    caption: 'Выкуп МХ-3',
    dataType: 'string'
  },
  {
    dataField: 'mh3DocStatusDescr',
    caption: 'Статус акта МХ-3',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  },
  {
    dataField: 'internalPieceId',
    caption: 'Внутренний номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'klPok',
    caption: 'Класс цинкового покрытия',
    dataType: 'string'
  },
  {
    dataField: 'cvet',
    caption: 'Цвет покрытия',
    dataType: 'string'
  },
  {
    dataField: 'dateOm',
    caption: 'Дата отгрузки Северсталь',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },

  {
    dataField: 'deliveryId',
    caption: 'Номер поставки',
    dataType: 'string'
  },
  {
    dataField: 'shipperName',
    caption: 'ФИО отгрузившего',
    dataType: 'string'
  },
  {
    dataField: 'invoice',
    caption: 'Номер накладной перв.плеча',
    dataType: 'string'
  },
  {
    dataField: 'marka',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'note',
    caption: 'Комментарий',
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: '№ партии SAP',
    dataType: 'string'
  },
  {
    dataField: 'onHoldFlag',
    caption: 'Карантин',
    dataType: 'boolean'
  },
  {
    dataField: 'decision',
    caption: 'Решение',
    dataType: 'string'
  },
  {
    dataField: 'materialSize',
    caption: 'Профили размера',
    dataType: 'string'
  },
  {
    dataField: 'departureDate',
    caption: 'Дата убытия баржи',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'conservationQmet',
    caption: 'Тип консервации',
    dataType: 'string'
  },
  {
    dataField: 'grPoverh',
    caption: 'Группа поверхности',
    dataType: 'string'
  },
  {
    dataField: 'cost',
    caption: 'Стоимость',
    dataType: 'number'
  }

];

export default columnDataM4;
